import React from 'react';
import { FcGoogle } from 'react-icons/fc';

const BackendUrl = process.env.REACT_APP_Backend_Url;

const GoogleLoginButton = ({ text = "Continuer avec Google" }) => {
  const handleGoogleLogin = () => {
    // Rediriger vers le backend pour initier OAuth
    window.location.href = `${BackendUrl}/api/auth/google`;
  };

  return (
    <button
      type="button"
      onClick={handleGoogleLogin}
      className="google-login-button"
      style={{
        width: '100%',
        padding: '12px 20px',
        border: '2px solid #e0e0e0',
        borderRadius: '8px',
        backgroundColor: '#ffffff',
        color: '#333',
        fontSize: '16px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#f8f8f8';
        e.currentTarget.style.borderColor = '#008751';
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 135, 81, 0.15)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#ffffff';
        e.currentTarget.style.borderColor = '#e0e0e0';
        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
      }}
    >
      <FcGoogle size={24} />
      <span>{text}</span>
    </button>
  );
};

export default GoogleLoginButton;
